// @flow

import type { ValidOption } from '../ui/design-system/select/select';

export type ReturnLabel = $ReadOnly<{|
  firstName: string,
  lastName: string,
  email: string,
  companyName: string,
  addressLine1: string,
  addressLine2: string,
  addressLine3: string,
  city: string,
  zipCode: string,
  countryCode: ValidOption,
  phone: string,
  orderNumber: string,
  parcelWeight: string,
  returnReason: string,
  pdfUrl: string,
|}>;

export type SerializedReturnLabel = $ReadOnly<{|
  first_name: string,
  last_name: string,
  email: string,
  company_name: string,
  address_line1: string,
  address_line2: string,
  address_line3: string,
  city: string,
  zip_code: string,
  country_code: string,
  phone: string,
  order_number: string,
  parcel_weight: string,
  return_reason: string,
|}>;

export type SerializedResponseReturnLabel = $ReadOnly<{|
  return_label: {
    first_name: string,
    last_name: string,
    email: string,
    company_name: string,
    address_line1: string,
    address_line2: string,
    address_line3: string,
    city: string,
    zip_code: string,
    country_code: string,
    phone: string,
    order_number: string,
    parcel_weight: string,
    return_reason: string,
  },
  pdf_url: string,
|}>;

export const serialized = (
  returnLabel: ReturnLabel,
): SerializedReturnLabel => ({
  first_name: returnLabel.firstName,
  last_name: returnLabel.lastName,
  email: returnLabel.email,
  company_name: returnLabel.companyName,
  address_line1: returnLabel.addressLine1,
  address_line2: returnLabel.addressLine2,
  address_line3: returnLabel.addressLine3,
  city: returnLabel.city,
  zip_code: returnLabel.zipCode,
  country_code: String(returnLabel.countryCode.value),
  phone: returnLabel.phone,
  order_number: returnLabel.orderNumber,
  parcel_weight: returnLabel.parcelWeight,
  return_reason: returnLabel.returnReason,
});

export const deserialized = (
  result: SerializedResponseReturnLabel,
): ReturnLabel => ({
  firstName: result.return_label.first_name,
  lastName: result.return_label.last_name,
  email: result.return_label.email,
  companyName: result.return_label.company_name,
  addressLine1: result.return_label.address_line1,
  addressLine2: result.return_label.address_line2,
  addressLine3: result.return_label.address_line3,
  city: result.return_label.city,
  zipCode: result.return_label.zip_code,
  countryCode: {
    value: result.return_label.country_code,
    label: result.return_label.country_code,
  },
  phone: result.return_label.phone,
  orderNumber: result.return_label.order_number,
  parcelWeight: result.return_label.parcel_weight,
  returnReason: result.return_label.return_reason,
  pdfUrl: result.pdf_url,
});
